<template>
  <div class="schedule">
    <div>
      <!-- Modal finalizar -->
      <b-modal
        size="md"
        no-close-on-backdrop
        hide-footer
        id="modalFinishCareSchedule"
        title="FINALIZAR"
      >
        <CareScheduleFinish
          :schedule="schedule"
          v-on:finish="handleFinishSchedule()"
        />
      </b-modal>

      <!-- Modal Filtrar -->
      <b-modal
        no-close-on-backdrop
        centered
        hide-header-close
        hide-footer
        id="imprimir"
        title="FILTRAR"
      >
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0">
          <h6 class="worksansr upper-text">Status</h6>
          <select v-model="status" class="form-control">
            <option value="PENDENTE">CUIDADOS PENDENTES</option>
            <option value="FINALIZADO">CUIDADOS FINALIZADOS</option>
            <option value="INATIVO">CUIDADOS APAGADOS</option>
            <option value="ALL">TODOS</option>
          </select>
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0">
          <h6 class="worksansr upper-text">Data de início</h6>
          <input type="date" v-model="start_date" class="form-control" />
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0">
          <h6 class="worksansr upper-text">Data de término</h6>
          <input v-model="end_date" type="date" class="form-control" />
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <ErrorsMessages :errors="errors" />
          <b-button class="btn-cancel m-1" @click="$bvModal.hide('imprimir')"
            >CANCELAR</b-button
          >
          <v-btn class="btn-filter-sidebar float-right" @click="handleFilter">
            <i class="fas fa-filter mr-2 text-twenty"></i>
            FILTRAR
          </v-btn>
        </div>
      </b-modal>

      <!-- Botao Filtrar -->
      <div class="row">
        <div class="col-12 text-right">
          <v-btn @click="$bvModal.show('imprimir')" class="btn-filter">
            <i
              :class="[
                'fas fa-filter text-twenty',
                width < 600 ? 'mr-0' : 'mr-2',
              ]"
            ></i
            ><span v-if="width > 600">FILTRAR</span></v-btn
          >
        </div>
      </div>

      <b-overlay :show="loading" opacity="0.99">
        <div class="p-5 v-clean" v-if="schedules.length == 0">
          <h6 class="text-center worksansr upper-text">Sem resultados!</h6>
        </div>

        <v-expansion-panels
          v-model="panel_group_prescription_care"
          hover
          multiple
          tile
          class="border border-for"
        >
          <v-expansion-panel
            v-for="(schedule, key_group) in schedules"
            :key="key_group"
          >
            <v-expansion-panel-header>
              <div class="row">
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                  <h6 class="mb-0 check-text-center">
                    RESIDENTE:
                    {{ schedule.resident_name }}
                  </h6>

                  <h6 class="mb-0 worksansr check-text-center">
                    VALIDADE: {{ formatDate(schedule.start_date, false) }} até
                    {{ formatDate(schedule.end_date, false) }}
                  </h6>
                </div>

                <!-- PRESCRIÇÃO -->
                <div
                  class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 d-flex align-items-center"
                >
                  <img
                    v-if="
                      !schedule.finish_user || schedule.status == 'PENDENTE'
                    "
                    class="mr-2 no-user-photo-url"
                    :src="require('../../../assets/user.png')"
                  />

                  <img
                    v-if="schedule.finish_user && schedule.status != 'INATIVO'"
                    :class="[
                      'mr-2',
                      schedule.finish_user.photo_url
                        ? 'user-photo-url'
                        : 'no-user-photo-url',
                    ]"
                    :src="
                      schedule.finish_user.photo_url
                        ? schedule.finish_user.photo_url
                        : require('../../../assets/user.png')
                    "
                  />

                  <div>
                    <h6 class="legends mb-0">
                      PRESCRIÇÃO
                      <span
                        :class="[
                          handleClassStatusGroupPrescriptionCare(
                            schedule.status
                          ),
                        ]"
                      >
                        {{
                          {
                            PENDENTE: "PENDENTE",
                            CANCELADO: "CANCELADA",
                            FINALIZADO: "FINALIZADA",
                            INATIVO: "APAGADA",
                          }[schedule.status] || ""
                        }}
                      </span>

                      <span
                        v-if="
                          schedule.finish_user && schedule.status != 'INATIVO'
                        "
                      >
                        POR
                      </span>
                    </h6>

                    <h6
                      v-if="
                        schedule.finish_user && schedule.status != 'INATIVO'
                      "
                      class="legends worksansr mb-0"
                    >
                      {{
                        professionalClassCouncilValue({
                          id: schedule.finish_user
                            .professional_class_council_id,
                          name: schedule.finish_user.name,
                          value:
                            schedule.finish_user
                              .professional_class_council_value,
                          cpf: schedule.finish_user.cpf,
                          office: schedule.finish_user.office,
                        })
                      }}
                    </h6>
                  </div>
                </div>

                <!-- APRAZAMENTO -->
                <div
                  class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 d-flex align-items-center"
                >
                  <img
                    v-if="
                      !schedule.user_finish_prescription_care_time ||
                      schedule.status_prescription_care_time == 'PENDENTE'
                    "
                    class="mr-2 no-user-photo-url"
                    :src="require('../../../assets/user.png')"
                  />

                  <img
                    v-if="
                      schedule.user_finish_prescription_care_time &&
                      schedule.status_prescription_care_time != 'INATIVO'
                    "
                    :class="[
                      'mr-2',
                      schedule.user_finish_prescription_care_time.photo_url
                        ? 'user-photo-url'
                        : 'no-user-photo-url',
                    ]"
                    :src="
                      schedule.user_finish_prescription_care_time.photo_url
                        ? schedule.user_finish_prescription_care_time.photo_url
                        : require('../../../assets/user.png')
                    "
                  />

                  <div>
                    <h6 class="legends mb-0">
                      APRAZAMENTO
                      <span
                        :class="[
                          handleClassStatusGroupPrescriptionCare(
                            schedule.status_prescription_care_time
                          ),
                        ]"
                      >
                        {{
                          {
                            PENDENTE: "PENDENTE",
                            CANCELADO: "CANCELADO",
                            FINALIZADO: "FINALIZADO",
                            INATIVO: "APAGADO",
                          }[schedule.status_prescription_care_time] || ""
                        }}
                      </span>

                      <span
                        v-if="
                          schedule.user_finish_prescription_care_time &&
                          schedule.status_prescription_care_time != 'INATIVO'
                        "
                      >
                        POR
                      </span>
                    </h6>

                    <h6
                      v-if="
                        schedule.user_finish_prescription_care_time &&
                        schedule.status_prescription_care_time != 'INATIVO'
                      "
                      class="legends worksansr mb-0"
                    >
                      {{
                        professionalClassCouncilValue({
                          id: schedule.user_finish_prescription_care_time
                            .professional_class_council_id,
                          name: schedule.user_finish_prescription_care_time
                            .name,
                          value:
                            schedule.user_finish_prescription_care_time
                              .professional_class_council_value,
                          cpf: schedule.user_finish_prescription_care_time.cpf,
                          office:
                            schedule.user_finish_prescription_care_time.office,
                        })
                      }}
                    </h6>
                  </div>
                </div>
              </div>
            </v-expansion-panel-header>

            <v-expansion-panel-content>
              <div
                v-if="schedule.status == 'FINALIZADO'"
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
              >
                <h6 class="status-center color-green check-text-center">
                  <i class="fas fa-exclamation-circle mr-1"></i>
                  Prescrição finalizada
                  {{
                    schedule.certificate
                      ? "com assinatura eletrônica"
                      : "com assinatura eletrônica"
                  }}
                </h6>

                <p v-if="schedule.certificate">
                  <span class="p-2 v-danger">{{ schedule.certificate }}</span>
                </p>

                <h6
                  class="status-center color-green check-text-center"
                  v-if="schedule.status_prescription_care_time == 'FINALIZADO'"
                >
                  <i class="fas fa-exclamation-circle mr-1"></i>
                  Aprazamento finalizado
                  {{
                    schedule.prescription_care_time_certificate
                      ? "com assinatura eletrônica"
                      : "com assinatura eletrônica"
                  }}
                </h6>

                <p v-if="schedule.prescription_care_time_certificate">
                  <span class="p-2 v-danger">{{
                    schedule.prescription_care_time_certificate
                  }}</span>
                </p>
              </div>

              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right pl-0 pr-0"
              >
                <v-btn
                  v-if="schedule.status == 'FINALIZADO'"
                  @click="handlePrint(schedule)"
                  class="btn-print m-1"
                >
                  <i
                    :class="[
                      'fas fa-print text-twenty',
                      width < 600 ? 'mr-0 ' : 'mr-2',
                    ]"
                  ></i>
                  <span v-if="width > 600">IMPRIMIR</span>
                </v-btn>
              </div>
              <div
                v-for="(
                  prescription_care, key_care
                ) in schedule.prescription_cares"
                :key="key_care"
                class="care"
              >
                <div class="row">
                  <div
                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 v-clean mb-2"
                  >
                    <h6
                      class="color-deleted text-thirteen check-text-center"
                      v-if="
                        prescription_care.prescription_care_status == 'EXCLUIDO'
                      "
                    >
                      ESTE CUIDADO FOI EXCLUIDO DA PRESCRIÇÃO!
                    </h6>

                    <h6
                      class="color-blue text-thirteen check-text-center"
                      v-if="prescription_care.edited == 1"
                    >
                      ESTE CUIDADO FOI EDITADO -
                      {{ formatDate(prescription_care.edited_date, false) }}
                    </h6>
                    <div class="row">
                      <div
                        class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-12 d-flex justify-content-center align-items-center"
                      >
                        <i class="fas fa-capsules fa-2x color-blue"></i>
                      </div>

                      <div class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-12">
                        <h6 class="mb-0 color-black check-text-center">
                          {{ prescription_care.care_name }}
                        </h6>

                        <div class="d-flex residenttop-content">
                          <h6
                            class="btn-pendent"
                            v-if="
                              prescription_care.type_of_recipe_name ==
                              'CONTROLE ESPECIAL - 2 VIAS'
                            "
                          >
                            CONTROLE ESPECIAL
                          </h6>
                        </div>
                      </div>

                      <div
                        class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 d-flex check-justifique-right align-items-center pr-5"
                      >
                        <div>
                          <h6 class="mb-0 check-text-right">
                            {{ prescription_care.care_amount_of_times_name }}
                          </h6>

                          <h6 class="mb-0 worksansr check-text-right">
                            {{ handleDuration(prescription_care.duration) }}
                          </h6>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12 col-12">
                        <p class="mb-0 worksansr legends">
                          Frequência:
                          {{ handleFrequency(prescription_care.frequency) }}
                          <br />
                        </p>

                        <p
                          class="mb-0 worksansr legends"
                          v-if="prescription_care.frequency != 'EVENTUAL'"
                        >
                          Repetição:
                          {{
                            handleEvery(
                              prescription_care.every,
                              prescription_care.frequency
                            )
                          }}
                        </p>

                        <p
                          class="mb-0 worksansr legends"
                          v-if="prescription_care.frequency == 'SEMANAL'"
                        >
                          Dias da semana:
                          {{ prescription_care.dom && "DOM" }}
                          {{ prescription_care.seg && "SEG" }}
                          {{ prescription_care.ter && "TER" }}
                          {{ prescription_care.qua && "QUA" }}
                          {{ prescription_care.qui && "QUI" }}
                          {{ prescription_care.sex && "SEX" }}
                          {{ prescription_care.sab && "SAB" }}

                          <br />
                        </p>

                        <p
                          class="mb-0 worksansr legends"
                          v-if="prescription_care.care_amount_of_times_name"
                        >
                          Quantidade diária:
                          {{ prescription_care.care_amount_of_times_name }}
                        </p>

                        <div
                          v-if="
                            prescription_care.care_amount_of_times_type ==
                            'SHIFTS'
                          "
                          class="col-xl-4 col-lg-5 col-md-6 col-sm-12 col-12 v-clean mt-1 mb-1"
                        >
                          <div class="row">
                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pt-0 pb-0"
                            >
                              <h6 class="mb-0">TURNO</h6>
                            </div>
                            <!-- <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pt-0 pb-0"
                            >
                              <h6 class="mb-0">QUANTIDADE</h6>
                            </div> -->
                          </div>
                        </div>

                        <p
                          class="mb-0 worksansr legends"
                          v-if="
                            prescription_care.frequency != 'EVENTUAL' &&
                            (prescription_care.duration == 'ATE_A_DATA' ||
                              prescription_care.duration ==
                                'DURANTE_UM_PERIODO')
                          "
                        >
                          Data de início:
                          {{ formatDate(prescription_care.start_date, false) }}
                        </p>

                        <p
                          class="mb-0 worksansr legends"
                          v-if="prescription_care.frequency != 'EVENTUAL'"
                        >
                          Duração:
                          {{ handleDuration(prescription_care.duration) }}
                        </p>

                        <p
                          class="mb-0 worksansr legends"
                          v-if="
                            prescription_care.frequency != 'EVENTUAL' &&
                            prescription_care.duration == 'DURANTE_UM_PERIODO'
                          "
                        >
                          Período de:
                          {{ prescription_care.duration_time }} dia(s)
                        </p>

                        <p
                          class="mb-0 worksansr legends"
                          v-if="
                            prescription_care.frequency != 'EVENTUAL' &&
                            prescription_care.duration == 'ATE_A_DATA'
                          "
                        >
                          Data de término:
                          {{ formatDate(prescription_care.end_date, false) }}
                        </p>

                        <p
                          class="mb-0 worksansr legends"
                          v-if="prescription_care.instruction"
                        >
                          Instrução:
                          {{ prescription_care.instruction }}
                        </p>

                        <h6 class="mt-2 legends">
                          CUIDADO CADASTRADO POR:
                          {{ prescription_care.user_name }}
                        </h6>
                      </div>

                      <div
                        class="col-xl-5 col-lg-5 col-md-6 col-sm-12 col-12 d-flex align-items-start"
                      >
                        <!-- d-flex align-items-center -->
                        <div
                          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                        >
                          <div
                            class="row"
                            v-for="prescription_care_time in prescription_care.prescription_care_time"
                            :key="prescription_care_time.id"
                          >
                            <div
                              v-show="prescription_care.frequency != 'EVENTUAL'"
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12"
                            >
                              <LabelRequiredField label="HORÁRIO" />
                              <input
                                disabled
                                v-if="schedule.status == 'INATIVO'"
                                :value="prescription_care_time.time"
                                type="time"
                                class="form-control"
                              />

                              <input
                                :disabled="
                                  prescription_care.prescription_care_status ==
                                    'EXCLUIDO' ||
                                  prescription_care.edited == 1 ||
                                  prescription_care_time.time
                                "
                                v-if="
                                  prescription_care_time.time &&
                                  schedule.status != 'INATIVO'
                                "
                                :value="prescription_care_time.time"
                                :ref="`schedule_${schedule.id}`"
                                :data-id="prescription_care_time.id"
                                :data-prescription_care_id="
                                  prescription_care_time.prescription_care_id
                                "
                                type="time"
                                class="form-control"
                              />

                              <input
                                v-if="
                                  !prescription_care_time.time &&
                                  schedule.status != 'INATIVO'
                                "
                                :ref="`schedule_${schedule.id}`"
                                :data-id="prescription_care_time.id"
                                :data-prescription_care_id="
                                  prescription_care_time.prescription_care_id
                                "
                                type="time"
                                class="form-control"
                                @input="handleDistributeSchedules"
                              />
                            </div>
                          </div>

                          <div
                            v-if="
                              prescription_care.frequency != 'EVENTUAL' &&
                              prescription_care.prescription_care_time.find(
                                (time) => (time.time ? true : false)
                              )
                            "
                            class="text-right"
                          >
                            <v-btn
                              @click="handleEditTime(prescription_care)"
                              class="v-primary"
                              ><i class="fas fa-edit mr-2"></i> EDITAR
                              HORÁRIO(S)</v-btn
                            >
                          </div>

                          <div
                            v-if="
                              prescription_care.frequency != 'EVENTUAL' &&
                              schedule.status_prescription_care_time ==
                                'PENDENTE' &&
                              prescription_care.prescription_care_time.length >
                                0 &&
                              !prescription_care.prescription_care_time[0].time
                            "
                            class="text-right"
                          >
                            <v-btn
                              :disabled="loadingFinishSchedule"
                              @click="handleModalFinishCareSchedule(schedule)"
                              class="btn-save"
                            >
                              <i class="fas fa-check mr-2 text-twenty"></i>
                              {{
                                loadingFinishSchedule ? "CARREGANDO" : "SALVAR"
                              }}
                            </v-btn>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <ErrorsMessages :errors="errors" />

                <div :disabled="loadingUpdate" class="col-md-12 text-right">
                  <confirmation-dialog
                    :loading="loadingDeleteSchedule"
                    :disabled="loadingDeleteSchedule"
                    v-if="
                      schedule.status_prescription_care_time == 'FINALIZADO'
                    "
                    message-title="CONFIRMAÇÃO"
                    message-body="Deseja realmente apagar o aprazamento?"
                    open-left-icon="fa-trash"
                    open-class="btn-delete"
                    open-text="REMOVER"
                    @yes="handleDelete(schedule.id)"
                  />

                  <v-btn
                    :disabled="loadingFinishSchedule"
                    v-if="
                      schedule.status_prescription_care_time == 'FINALIZADO'
                    "
                    @click="update(schedule)"
                    class="btn-save m-1"
                  >
                    <i class="fas fa-save mr-2 text-twenty"></i>
                    {{ loadingFinishSchedule ? "CARREGANDO" : "SALVAR" }}
                  </v-btn>

                  <v-btn
                    :disabled="loadingFinishSchedule"
                    v-if="schedule.status_prescription_care_time == 'PENDENTE'"
                    @click="handleModalFinishCareSchedule(schedule)"
                    class="btn-save m-1"
                  >
                    <i class="fas fa-check mr-2 text-twenty"></i>
                    {{ loadingFinishSchedule ? "CARREGANDO" : "FINALIZAR" }}
                  </v-btn>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <b-pagination
            align="right"
            v-if="schedules.length > 0"
            @input="paginate()"
            v-model="page"
            :total-rows="total"
            :per-page="5"
          />
        </div>

        <b-modal
          no-close-on-backdrop
          id="edit_time"
          title="ALTERAR HORÁRIO(S)"
          hide-footer
          hide-header-close
        >
          <EditCareTime
            :prescription_care="edit_prescription_care"
            @paginate="paginate"
          />
        </b-modal>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../templates/Components/ErrorsMessages";

import LabelRequiredField from "../../../templates/Components/LabelRequiredField";

import ConfirmationDialog from "../../../templates/Components/ConfirmationDialog";

import CareScheduleFinish from "../../../templates/Prescription/Care/Finish";

import EditCareTime from "../../../templates/Prescription/Care/EditCareTime";

import api from "../../../services/api";

import toast from "../../../lib/ToastNotification";

import routes from "../../../routes";

import { userData } from "../../../lib/functions";

import {
  formatDate,
  numbersOnly,
  professionalClassCouncilValue,
} from "../../../lib/format";

export default {
  name: "CareTime",

  components: {
    ErrorsMessages,
    LabelRequiredField,
    ConfirmationDialog,
    CareScheduleFinish,
    EditCareTime,
  },

  data() {
    return {
      page: 1,

      total: 0,

      isActiveFilter: false,

      permissions: {},

      user_id: "",

      rest_home_id: "",

      resident_id: "",

      resident: {},

      status: "ALL",

      start_date: "",

      end_date: "",

      schedules: [],

      schedule: null,

      group_prescription_care: {},

      prescription_care: {},

      edit_prescription_care: {},

      errors: [],

      loading: false,

      loadingUpdate: false,

      loadingDeleteSchedule: false,

      loadingFinishSchedule: false,

      keyGroup: 0,

      keycare: 0,

      width: window.screen.width,

      panel_group_prescription_care: [],

      panel_prescription_care: [],
    };
  },

  created() {
    this.retrieve();
    window.addEventListener("resize", this.handleOnResize);
    this.handleOnResize();
  },

  destroyed() {
    window.removeEventListener("resize", this.handleOnResize);
    this.handleOnResize();
  },

  methods: {
    formatDate,
    numbersOnly,
    professionalClassCouncilValue,

    handleClassStatusGroupPrescriptionCare(status) {
      return (
        {
          PENDENTE: "text-warning",
          CANCELADO: "text-cancel",
          FINALIZADO: "text-sucess",
          INATIVO: "text-inativi",
        }[status] || ""
      );
    },

    handleEditTime(prescription_care) {
      this.edit_prescription_care = prescription_care;
      this.$bvModal.show("edit_time");
    },

    handleDistributeSchedules(e) {
      let { value } = e.target;
      let { id, prescription_care_id } = e.target.dataset;

      let inputs = document.querySelectorAll(
        `input[data-prescription_care_id="${prescription_care_id}"]`
      );

      if (id != inputs[0].dataset.id) {
        return;
      }

      if (inputs.length == 1) {
        return;
      }

      if (inputs[1].value) {
        return;
      }

      let countTimes = 0;

      for (let input of inputs) {
        if (input.dataset.prescription_care_id == prescription_care_id) {
          countTimes++;
        }
      }

      if (countTimes == 5 || countTimes == 7 || countTimes == 9) {
        return;
      }

      let every = 24 / countTimes;

      if (String(every).length == 1) {
        every = `0${every}:00`;
      } else if (String(every).length == 2) {
        every = `${every}:00`;
      }

      for (let i = 0; i < inputs.length; i++) {
        let time =
          parseInt(numbersOnly(value)) +
          parseInt(numbersOnly(i == 0 ? 0 : every)) * i;

        if (String(time).length == 1) {
          time = `0${time}00`;
        } else if (String(time).length == 2) {
          time = `${time}00`;
        } else if (String(time).length == 3) {
          time = `0${time}`;
        }

        if (parseInt(time) == 2400) {
          time = "00:00";
        } else if (parseInt(time) > 2400) {
          time = null;
        }

        if (time) {
          let half = Math.floor(String(time).length / 2);
          inputs[i].value =
            String(time).substr(0, half) + ":" + String(time).substr(half);
        }
      }
    },

    handleOnResize() {
      this.width = window.innerWidth;
    },

    handleFrequency(frequency) {
      let frequencys = {
        DIARIO: "DIÁRIO",
        SEMANAL: "SEMANAL",
        MENSAL: "MENSAL",
        ANUAL: "ANUAL",
        EVENTUAL: "EVENTUAL",
        default: "NÃO ENCONTRADO!!!",
      };

      return frequencys[frequency] || frequencys.default;
    },

    handleEvery(every, frequency) {
      let frequencys = {
        DIARIO: "DIA",
        SEMANAL: "SEMANA",
        MENSAL: "MÊS",
        ANUAL: "ANO",
      };

      return `A CADA ${every} ${frequencys[frequency]}`;
    },

    handleDuration(duration) {
      let durations = {
        CONTINUO: "CONTÍNUO",
        DURANTE_UM_PERIODO: "DURANTE UM PERÍODO",
        ATE_A_DATA: "ATÉ A DATA",
        default: "EVENTUAL",
      };

      return durations[duration] || durations.default;
    },

    async retrieve() {
      let { permissions, user } = userData();

      this.user_id = user.id;
      this.rest_home_id = user.rest_home_id;
      this.permissions = permissions;

      const { id } = routes.history.current.params;

      this.resident_id = id;

      await this.paginate();
    },

    async paginate(
      keyGroup = null,
      valueGoup = 0,
      keyCare = null,
      valueCare = 0
    ) {
      try {
        this.loading = true;
        this.panel_group_prescription_care = [];
        this.panel_prescription_care = [];
        this.schedules = [];
        this.errors = [];

        const {
          rest_home_id,
          resident_id,
          status,
          start_date,
          end_date,
          page,
        } = this;

        let params = {
          rest_home_id,
          resident_id,
          status,
          start_date,
          end_date,
          page,
          type: "NORMAL",
        };

        const response = await api.get("/rest-home/resident/care-schedules", {
          params,
        });

        const { error, errors, schedules, total } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.isActiveFilter = false;
          this.schedules = schedules;
          this.total = total;
          if (keyGroup) {
            this.panel_group_prescription_care = [valueGoup];
            if (keyCare) {
              this.panel_prescription_care = [valueCare];
            }
          }
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    handleChangeQuantity() {
      this.paginate();
    },

    handleFinishSchedule() {
      this.$bvModal.hide("modalFinishCareSchedule");
      this.paginate();
    },

    handleToBack: () => routes.go(-1),

    handleModalFinishCareSchedule(schedule) {
      let { user_id } = this;
      let { id, prescription_cares } = schedule;

      let prescription_care = [];
      let prescription_care_time = [];

      let refs = this.$refs[`schedule_${id}`];

      for (let item of refs) {
        let obj = {
          id: item.dataset.id,
          time: item.value,
          prescription_care_id: item.dataset.prescription_care_id,
        };

        prescription_care_time.push(obj);
      }

      for (let item of prescription_cares) {
        let obj = {
          id: item.id,
          frequency: item.frequency,
          edited: item.edited,
          end: item.end,
          group_prescription_care_start_date:
            item.group_prescription_care_start_date,
          group_prescription_care_end_date:
            item.group_prescription_care_end_date,
        };

        prescription_care.push(obj);
      }

      let params = {
        id,
        user_id,
        prescription_care,
        prescription_care_time,
      };

      schedule.params = params;

      this.schedule = schedule;

      this.$bvModal.show("modalFinishCareSchedule");
    },

    async update(schedule) {
      try {
        let { user_id } = this;
        let { id, prescription_cares } = schedule;

        let prescription_care = [];
        let prescription_care_time = [];

        let refs = this.$refs[`schedule_${id}`];

        for (let item of refs) {
          let obj = {
            id: item.dataset.id,
            time: item.value,
            prescription_care_id: item.dataset.prescription_care_id,
          };

          prescription_care_time.push(obj);
        }

        for (let item of prescription_cares) {
          let obj = {
            id: item.id,
            frequency: item.frequency,
          };

          prescription_care.push(obj);
        }

        let params = {
          id,
          user_id,
          prescription_care,
          prescription_care_time,
        };

        const response = await api.patch("/rest-home/care-schedule", params);

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.paginate();
          this.errors = [];
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async handleDelete(id) {
      try {
        let params = { id };

        const response = await api.patch(
          "/rest-home/care-schedule/clear-time",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");

          this.paginate();

          this.errors = [];
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },

    handlePrint({ id }) {
      let route = this.$router.resolve({
        name: "care-schedule_print",
        params: { id },
      });

      window.open(route.href, "_blank");
    },

    handleFilter() {
      this.paginate();
      this.$bvModal.hide("imprimir");
    },
  },
};
</script>

<style>
.schedule .care .capsule {
  width: 20px;
}

.schedule .care .name {
  margin-left: 10px;
  display: flex;
  flex-direction: column !important;
  justify-content: center;
}
.schedule .care .frequency {
  display: flex;
  flex-direction: column !important;
  justify-content: center;
  align-items: center;
}
.schedule .care .frequency strong {
  font-size: 18px;
}
.schedule .information-care {
  width: 34%;
}
.schedule .information-schedule {
  width: 65%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
